import { Provider, useIntercomContext } from './components/Provider'

export const IntercomClient = {
  Provider,
  use: useIntercomContext,
}
